/**
 * Valeurs par défaut utilisées dans les formulaires de garantie.
 */

/**
 * Phrase par défaut affichée dans le champ "Informations complémentaires"
 * (anciennement "diagnostic"). Préremplie pour toutes les nouvelles garanties
 * et reportée dans le PDF du contrat.
 */
export const DEFAULT_WARRANTY_DIAGNOSTIC =
  'Les petites fournitures et les lubrifiants restent à la charge du bénéficiaire. Veillez à entretenir le véhicule dans le respect des préconisations constructeur.';
